var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6685 8.51104e-08C16.7128 -0.000364765 12.8458 1.1723 9.55657 3.36971C6.26735 5.56712 3.70361 8.69056 2.18957 12.345C0.675537 15.9995 0.279209 20.0209 1.0507 23.9007C1.8222 27.7804 3.72687 31.3442 6.52385 34.1415C9.32082 36.9387 12.8845 38.8437 16.7641 39.6156C20.6438 40.3874 24.6652 39.9915 28.3199 38.4778C31.9745 36.9641 35.0982 34.4006 37.2959 31.1116C39.4936 27.8226 40.6666 23.9557 40.6666 20C40.6669 17.3736 40.1498 14.773 39.1449 12.3465C38.14 9.91997 36.667 7.71517 34.81 5.85797C32.9529 4.00078 30.7483 2.52756 28.3219 1.52244C25.8955 0.517328 23.2948 7.39371e-08 20.6685 8.51104e-08ZM32.004 26.3291L20.6685 33.1544L9.33109 26.5136V13.206L20.6685 6.84375L32.004 13.6137V26.3291Z",
    fill: "#F7941D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3847 14.9659V25.0341L20.6686 30.0682L11.9506 25.0341V14.9659L20.6686 9.93359L29.3847 14.9659Z",
    fill: "#F7941D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6686 19.9298V30.0682L11.9506 25.0341V14.9658L20.6686 19.9298Z",
    fill: "#F05503"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3847 14.9659L20.6686 19.9299L11.9506 14.9659L20.6686 9.93359L29.3847 14.9659Z",
    fill: "#F7941D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/Order.0eb109a18e50df2ac93e22a22fce1945.svg";
export { ForwardRef as ReactComponent };